var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/oncologist.a65b56b9.png","uri@2x": __webpack_public_path__ + "static/media/oncologist.bf943f53.png","uri@3x": __webpack_public_path__ + "static/media/oncologist.48490dfb.png",
    width: 50,
    height: 50
});